import api from "./apiLogisticsTool.js";

export default {
  GetCompanies() {
    return api.get("Companies/GetCompanies");
  }
};
